import classNames from 'classnames';
import { lessAgressiveColorMapper } from 'components/PostTrade/ProductModification/components/ValidationErrors.utils';
import { ActionButton, ButtonPanel, MessagesPanel } from 'components/secondaryMarket/shared/status';
import { KycScore } from 'components/secondaryMarket/shared/status/KycScore';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { useToggleFeature } from 'hooks/useToggleFeature';
import { FC } from 'react';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';

import { Comment } from './comment';
import type { ReadySidePanelProps } from './ReadySidePanel.connect';

const readyToPlaceOrder: SecondaryMarketFormError[] = [
  {
    fields: [],
    severity: 'Warning',
    translationKey: 'readyToPlaceOrder',
    values: {},
  },
];

export const ReadySidePanel: FC<ReadySidePanelProps> = ({
  children,
  onPlaceOrder,
  isOrderPlacementEnabled,
  onCommentChanged,
  comment,
  kycScore,
  kycDetails,
  className,
  backendReports,
}) => {
  const isKycHidden = useToggleFeature('HideKYCDisplayParis');
  return (
    <div className={classNames('d-flex flex-column overflow-y-auto', className)}>
      <PanelHeader color="primary" discreet />
      <PanelFooter color="primary" discreet statusKey="secondaryMarket.sidePanel.label.ready" icon="offline_bolt" />
      {!isKycHidden && kycScore !== undefined && <KycScore className="m-2" status={kycScore} details={kycDetails} />}
      <MessagesPanel
        errors={[...readyToPlaceOrder, ...backendReports]}
        className="flex-grow-1 pt-2"
        e2e="side-panel-header"
        colorToSeverity={lessAgressiveColorMapper}
      >
        {children}
      </MessagesPanel>

      <ButtonPanel>
        <Comment onCommentChanged={onCommentChanged} comment={comment} />
        <ActionButton
          color="primary"
          label="secondaryMarket.sidePanel.label.placeOrder"
          disabled={!isOrderPlacementEnabled}
          onClick={onPlaceOrder}
        />
      </ButtonPanel>
    </div>
  );
};
ReadySidePanel.displayName = 'ReadySidePanel';
